import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { Animated } from "react-animated-css";

class Card extends React.Component {
    render() {
        const { tournament, index } = this.props;
        return (
            <Animated animationIn="fadeInUp" style={{ float: 'left' }} animationInDelay={50 * index}>
                <Link to={`/admin/tournaments/add/${tournament.id}`}>
                    <figure className="card p-4 margin-right d-flex flex-column justify-content-center pointer hover-red" style={{ float: 'left', width: 250, height: 280 }}>
                        <img alt="" src={`${tournament.Affiliate ? tournament.Affiliate.Logo : "/images/logos/logo.png"}`} className="align-self-center" style={{ width: 100, }} />
                        <span className="align-self-center black font-18 text-center line1 margin-top-half anton toUpper">{tournament.Name}</span>
                        <span className="align-self-center gray hind">{moment(tournament.DateStart).format('MMM Do')}{(tournament.DateEnd && moment(tournament.DateEnd).format('YYYYMMDD') !== moment(tournament.DateStart).format('YYYYMMDD')) ? ' - ' +
                            (moment(tournament.DateStart).format('MMM') === moment(tournament.DateEnd).format('MMM') ? moment(tournament.DateEnd).format('Do') : moment(tournament.DateEnd).format('MMM Do')) : ''}{' '}{moment(tournament.DateStart).format('YYYY')}</span>
                        {tournament.IdSeason !== '0' && <span className="align-self-center green hind font-8">(SL: {tournament.IdSeason})</span>}
                    </figure>
                </Link>
            </Animated>
        )
    }
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/private/tournaments/partials/card.js